import React, { useEffect, useState, useMemo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import { Profile, SidebarNav } from './components';
import i18n from 'translations/langEngine';
import { AMODULO_RECEPTIVO } from 'consts';
import { menuByModule } from 'routeConfig';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const classes = useStyles();

  const [translations, setTranslations] = useState({});

  const pages = useMemo(() => {
    return menuByModule[AMODULO_RECEPTIVO] || [];
  }, []);

  useEffect(() => {
    const fetchTranslations = async () => {
      const keys = [
        'MENU_DASHBOARD',
        'MENU_OPERACAO',
        'MENU_ORDENS_SERVICO',
        'MENU_MAPA_OPERACAO',
        'MENU_ITEM_CADASTRO',
        'MENU_CLIENTES',
        'MENU_USUARIOS',
        'MENU_CATEGORIAS_SERVICOS',
        'MENU_ITEM_SERVICOS',
        'MENU_MOTIVOS_CANCELAMENTO',
        'MENU_VENDEDORES',
        'MENU_TIPO_VEICULO',
        'MENU_ITEM_SAIR'
      ];

      const result = await i18n.fetchTerms(keys);
      setTranslations(result || {});
    };

    fetchTranslations();
  }, []);

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav
          pages={pages}
          translations={translations}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;